import { render } from "./CommissionTable.vue?vue&type=template&id=16c3130e"
import script from "./CommissionTable.vue?vue&type=script&lang=js"
export * from "./CommissionTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__